export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5042.badb4ae8.jpg";